import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import DiscountCodeProductComponent from '../components/DiscountCodeProductComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { fechaHora } from '../utils/giftCards';
import {
    detalleParaEditar, editar, fechaParaInput, etiquetaTipo, etiquetaAccion, resumenDelCambio,
} from '../utils/discountCodesApi';

/**
 * Editar un código de descuento (pedido del local, 2026-10-11).
 *
 * - El texto del código y el tipo NO se editan: el código es la clave que guardan las compras, y
 *   cambiar el tipo convertiría un cupón tipeable en uno de medio de pago o al revés.
 * - **El nombre de quien edita es obligatorio**: el login del local es compartido, la cuenta no
 *   dice quién fue. Queda en el historial con el antes y el después.
 * - Un código de uso único ya usado también se puede corregir (la pantalla no lo filtra).
 */
class EditDiscountCodePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: false, role: 0,
            code: new URLSearchParams(props.location.search).get('code') || '',
            cargando: true, errorCarga: null,
            form: null, products: {}, initialCodes: [], history: [],
            responsable: '', enviando: false, error: null,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
        try {
            const data = await detalleParaEditar(this.state.code);
            const c = data.code;
            this.setState({
                cargando: false,
                form: {
                    type: c.type,
                    used: Number(c.used) === 1,
                    discount: String(c.discount == null ? 0 : c.discount),
                    from: fechaParaInput(c.from),
                    to: fechaParaInput(c.to),
                    any: Number(c.any) === 1,
                    max_amount: c.max_amount ? String(c.max_amount) : '',
                    unique: Number(c.single_use) === 1,
                },
                initialCodes: c.products || [],
                history: data.history || [],
            });
        } catch (e) {
            this.setState({ cargando: false, errorCarga: e.message || 'No se pudo cargar el código.' });
        }
    }

    setCampo = (campo, valor) => this.setState((s) => ({ form: { ...s.form, [campo]: valor }, error: null }));

    guardar = async () => {
        if (this.state.enviando) return;
        const { form, products, responsable } = this.state;
        if (responsable.trim().length < 2) {
            this.setState({ error: 'Escribí tu nombre: queda registrado quién hizo el cambio.' });
            return;
        }
        const discount = parseInt(form.discount, 10);
        if (Number.isNaN(discount)) {
            this.setState({ error: 'Poné el porcentaje de descuento.' });
            return;
        }
        this.setState({ enviando: true, error: null });
        try {
            await editar(this.state.code, {
                discount,
                from: form.from,
                to: form.to,
                any: form.any,
                // Con "aplica a todos" la lista de productos no se usa: se manda vacía.
                products: form.any ? [] : Object.values(products).map((p) => p.code),
                max_amount: form.max_amount === '' ? 0 : parseInt(form.max_amount, 10),
                unique: form.unique,
            }, responsable.trim());
            navigateTo('/discountCodes');
        } catch (e) {
            this.setState({ enviando: false, error: e.message || 'No se pudo guardar.' });
        }
    }

    renderHistorial() {
        const { history } = this.state;
        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom"><h6 className="m-0">Historial</h6></div>
                <ul className="list-group list-group-flush">
                    {history.length === 0 && (
                        <li className="list-group-item p-3 text-muted">
                            Sin cambios registrados (el código es anterior al historial).
                        </li>
                    )}
                    {history.map((h, i) => (
                        <li key={i} className="list-group-item p-3">
                            <strong>{etiquetaAccion(h.action)}</strong>
                            {' · '}{fechaHora(h.changed_at)}
                            {' · '}{h.changed_by_name || <span className="text-muted">sin nombre</span>}
                            {h.changed_by && <span className="text-muted"> ({h.changed_by})</span>}
                            {h.action === 'edicion' && <div className="text-muted small">{resumenDelCambio(h)}</div>}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    renderForm() {
        const { form, code, responsable, enviando, error } = this.state;
        return (
            <div className="row">
                <div className="col-lg-6">
                    <div className="card card-small mb-4">
                        <div className="card-header border-bottom">
                            <h6 className="m-0">Código {code}</h6>
                        </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item p-3">
                                <p className="text-muted mb-3">
                                    Tipo: <strong>{etiquetaTipo(form.type)}</strong>
                                    {form.used && ' · ya usado'}. El texto del código y el tipo no se cambian.
                                </p>
                                <div className="form-row">
                                    <div className="form-group col-md-4">
                                        <label htmlFor="discount">Descuento (%)</label>
                                        <input id="discount" type="number" className="form-control" value={form.discount}
                                            onChange={(e) => this.setCampo('discount', e.target.value)} />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label htmlFor="any">Aplica a todos?</label>
                                        <select id="any" className="custom-select" value={String(form.any)}
                                            onChange={(e) => this.setCampo('any', e.target.value === 'true')}>
                                            <option value="true">Sí</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label htmlFor="unique">Uso único?</label>
                                        <select id="unique" className="custom-select" value={String(form.unique)}
                                            onChange={(e) => this.setCampo('unique', e.target.value === 'true')}>
                                            <option value="true">Sí</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="from">Fecha desde</label>
                                        <input id="from" type="date" className="form-control" value={form.from}
                                            onChange={(e) => this.setCampo('from', e.target.value)} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="to">Fecha hasta</label>
                                        <input id="to" type="date" className="form-control" value={form.to}
                                            onChange={(e) => this.setCampo('to', e.target.value)} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="max_amount">Descuento máximo ($)</label>
                                        <input id="max_amount" type="number" className="form-control" value={form.max_amount}
                                            placeholder="Sin tope" onChange={(e) => this.setCampo('max_amount', e.target.value)} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="responsable">Tu nombre</label>
                                        <input id="responsable" type="text" className="form-control" value={responsable}
                                            placeholder="Quién hace el cambio" maxLength={60}
                                            onChange={(e) => this.setState({ responsable: e.target.value, error: null })} />
                                    </div>
                                </div>
                                {error && <div className="alert alert-danger mb-3">{error}</div>}
                                <button type="button" className="btn btn-accent mr-2" disabled={enviando} onClick={this.guardar}>
                                    {enviando ? 'Guardando…' : 'Guardar cambios'}
                                </button>
                                <button type="button" className="btn btn-outline-secondary" disabled={enviando}
                                    onClick={() => navigateTo('/discountCodes')}>
                                    Cancelar
                                </button>
                            </li>
                        </ul>
                    </div>
                    {this.renderHistorial()}
                </div>
                <div className="col-lg-6" style={{ display: form.any ? 'none' : 'block' }}>
                    <DiscountCodeProductComponent
                        initialCodes={this.state.initialCodes}
                        onChangeData={(value) => this.setState({ products: value })}
                    />
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.checked) return (<div></div>);
        const { cargando, errorCarga } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={11} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Compras" subtitle="Editar código de descuento" />
                            {cargando && <div className="containerLoader" style={{ display: 'block', position: 'static' }}><div className="loader"></div></div>}
                            {errorCarga && (
                                <div className="alert alert-danger">
                                    {errorCarga}{' '}
                                    <button type="button" className="btn btn-link p-0" onClick={() => navigateTo('/discountCodes')}>Volver a la lista</button>
                                </div>
                            )}
                            {!cargando && !errorCarga && this.renderForm()}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EditDiscountCodePage;
